import { Form, Input } from 'antd';
import type { Rule } from 'antd/es/form';

type InputConfig = {
  name: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  type?: string;
  rules?: Rule[];
};

const TextField = ({ config }: { config: InputConfig }) => {
  const requiredRule: Rule[] = config.required
    ? [{ required: true, message: `Please enter ${config.label.toLowerCase()}` }]
    : [];

  const mergedRules = [...requiredRule, ...(config.rules ?? [])];
  return (
  <Form.Item
    key={config.name}
    name={config.name}
    label={config.label}
    rules={mergedRules.length ? mergedRules : undefined}
  >
    <Input type={config.type || 'text'} placeholder={config.placeholder} />
  </Form.Item>
);
}

export default TextField;
